import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { ControlLabel } from 'react-bootstrap';
import ModalForm from 'components/ModalForm';
import messages from './messages';
import styles from './styles.css';

const UpdateAmountForm = ({ handleSubmit, show, onHide }) => (
  <ModalForm
    onHide={onHide}
    show={show}
    handleSubmit={handleSubmit}
    title={<FormattedMessage {...messages.editAmount} />}
  >
    <ControlLabel className={styles.controlLabel} htmlFor="updatedAmount">
      <FormattedMessage {...messages.amount} />
      <Field
        required
        name="updatedAmount"
        component="input"
        step="0.01"
        type="number"
        className="form-control"
      />
    </ControlLabel>
    <ControlLabel className={styles.controlLabel} htmlFor="comment">
      <FormattedMessage {...messages.comment} />
      <Field
        name="comment"
        component="textarea"
        className="form-control"
      />
    </ControlLabel>
  </ModalForm>
);


UpdateAmountForm.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'UpdateAmount', enableReinitialize: true })(UpdateAmountForm);



// WEBPACK FOOTER //
// ./src/components/UpdateAmountForm/index.js